import { render, staticRenderFns } from "./AddressStatus.vue?vue&type=template&id=646f3ee2&scoped=true&"
import script from "./AddressStatus.vue?vue&type=script&lang=js&"
export * from "./AddressStatus.vue?vue&type=script&lang=js&"
import style0 from "./AddressStatus.vue?vue&type=style&index=0&id=646f3ee2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f3ee2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/Design/Input.vue').default,Select: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/From/select.vue').default})
